import { Button, ButtonProps } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useIsFormDisabled } from "shared/components/form/FormStateProvider";

export type CancelButtonProps = Omit<ButtonProps, "isLoading" | "type">;

export const FormCancelButton = React.forwardRef<
  HTMLButtonElement,
  CancelButtonProps
>(({ children, ...props }, ref) => {
  const { t } = useTranslation(["common"]);
  const isFormDisabled = useIsFormDisabled();
  return (
    <Button
      data-ls-enabled={true}
      data-public={true}
      colorScheme="secondary"
      isDisabled={isFormDisabled}
      ref={ref}
      {...props}
    >
      {children ? children : t("common:cancel")}
    </Button>
  );
});
FormCancelButton.displayName = "FormCancelButton";
